import { ComponentType } from 'react';

import { IslandName, IslandPropsMap } from './props';

type IslandLoader<N extends IslandName> = () => Promise<ComponentType<IslandPropsMap[N]>>;

/**
 * The components a Knockout page may mount:
 * for each component, add an entry here plus a contract in props.ts.
 *
 * Loaders are dynamic, so each island is its own chunk. The React runtime is
 * in the entry bundle.
 */
export const ISLANDS: { [N in IslandName]: IslandLoader<N> } = {
  'collapse-all-button': () =>
    import('@/components/buttons/CollapseAllButton').then((m) => m.CollapseAllButton),
  'trial-info-header': () =>
    import('@/components/staff-assignments/TrialInfoHeader').then((m) => m.TrialInfoHeader),
  'trials-list': () => import('@/components/trials-list/TrialsList').then((m) => m.TrialsList),
  'unit-groups-settings': () =>
    import('@/components/unit-groups/UnitGroupsSettings').then((m) => m.UnitGroupsSettings),
  'unit-group-field': () =>
    import('@/components/unit-groups/UnitGroupField').then((m) => m.UnitGroupField),
  'traits-list': () => import('@/components/traits-list/TraitsList').then((m) => m.TraitsList),
  'dimensions-list': () =>
    import('@/components/dimensions-list/DimensionsList').then((m) => m.DimensionsList),
  'dimension-records': () =>
    import('@/components/dimension-records/DimensionRecords').then((m) => m.DimensionRecords),
  'groups-list': () => import('@/components/groups-list/GroupsList').then((m) => m.GroupsList),
  'crop-varieties-list': () =>
    import('@/components/crop-varieties-list/CropVarietiesList').then((m) => m.CropVarietiesList),
  'document-tags-list': () =>
    import('@/components/document-tags-list/DocumentTagsList').then((m) => m.DocumentTagsList),
  'scheduled-visits-list': () =>
    import('@/components/scheduled-visits-list/ScheduledVisitsList').then(
      (m) => m.ScheduledVisitsList
    ),
  'trial-types-list': () =>
    import('@/components/trial-types-list/TrialTypesList').then((m) => m.TrialTypesList),
  'attribute-choices-list': () =>
    import('@/components/attribute-choices-list/AttributeChoicesList').then(
      (m) => m.AttributeChoicesList
    ),
  'countries-list': () =>
    import('@/components/countries-list/CountriesList').then((m) => m.CountriesList),
  'administrative-regions-list': () =>
    import('@/components/regions-list/RegionsList').then((m) => m.RegionsList),
  'agroclimatic-regions-list': () =>
    import('@/components/regions-list/RegionsList').then((m) => m.RegionsList),
  'trait-categories-list': () =>
    import('@/components/trait-categories-list/TraitCategoriesList').then(
      (m) => m.TraitCategoriesList
    ),
  'users-list': () => import('@/components/users-list/UsersList').then((m) => m.UsersList),
  'trial-activity-status-list': () =>
    import('@/components/trial-activity-status-list/TrialActivityStatusList').then(
      (m) => m.TrialActivityStatusList
    ),
  'trait-tags-list': () =>
    import('@/components/trait-tags-list/TraitTagsList').then((m) => m.TraitTagsList),
  'organizations-list': () =>
    import('@/components/organizations-list/OrganizationsList').then((m) => m.OrganizationsList),
  'sites-list': () => import('@/components/sites-list/SitesList').then((m) => m.SitesList),
  'crops-list': () => import('@/components/crops-list/CropsList').then((m) => m.CropsList),
  'stages-list': () => import('@/components/stages-list/StagesList').then((m) => m.StagesList),
  'seasons-list': () => import('@/components/seasons-list/SeasonsList').then((m) => m.SeasonsList),
  'names-list': () => import('@/components/names-list/NamesList').then((m) => m.NamesList),
  'programs-list': () =>
    import('@/components/programs-list/ProgramsList').then((m) => m.ProgramsList),
  'tpps-list': () => import('@/components/tpps-list/TppsList').then((m) => m.TppsList),
  'drivers-list': () => import('@/components/drivers-list/DriversList').then((m) => m.DriversList),
  'measurement-types-list': () =>
    import('@/components/measurement-types-list/MeasurementTypesList').then(
      (m) => m.MeasurementTypesList
    ),
  'organization-types-list': () =>
    import('@/components/organization-types-list/OrganizationTypesList').then(
      (m) => m.OrganizationTypesList
    ),
  'report-templates-list': () =>
    import('@/components/report-templates-list/ReportTemplatesList').then(
      (m) => m.ReportTemplatesList
    ),
};
